import { readInlineData, useLazyLoadQuery } from 'react-relay';
import { UnifiedProfileFragment$key } from 'graphql/__generated__/UnifiedProfileFragment.graphql';
import {
  UnifiedProfileQuery,
  UnifiedProfileQuery$data,
} from 'graphql/__generated__/UnifiedProfileQuery.graphql';
import { UNIFIED_PROFILE_FRAGMENT } from 'graphql/UnifiedProfileFragment';
import { UNIFIED_PROFILE_QUERY } from 'graphql/UnifiedProfileQuery';

/**
 * Used to verify if a particular username exists.
 *
 * @param username - username to validate
 * @returns boolean - true if the username exists, false otherwise
 */
const useValidatePublicUser = (pathProfileId: string): boolean => {
  if (!pathProfileId) {
    console.warn('useValidatePublicUser hook receied an empty pathProfileId');
    return false;
  }

  const unifiedProfileData = useLazyLoadQuery<UnifiedProfileQuery>(
    UNIFIED_PROFILE_QUERY,
    { internalId: pathProfileId },
    { fetchPolicy: 'store-or-network' },
  );

  let isProfileDataAvailable = false;
  const unifiedProfile = unifiedProfileData?.unified?.unifiedProfile;
  if (unifiedProfile && '__fragments' in unifiedProfile) {
    const profileFragmentData = readInlineData<UnifiedProfileFragment$key>(
      UNIFIED_PROFILE_FRAGMENT,
      unifiedProfile as NonNullable<
        UnifiedProfileQuery$data['unified']
      >['unifiedProfile'],
    );
    if (profileFragmentData?.accountInternalId) {
      isProfileDataAvailable = true;
    }
  }

  return isProfileDataAvailable;
};

export default useValidatePublicUser;
